import Box from '@mui/material/Box';

import type { SapConnectionController } from '@/presentation/controllers/sap-connection-controller.js';
import { SapConnectionSection } from '@/presentation/pages/clients/components/sap-connection-section.js';

interface Props {
    clientId: string | undefined;
    controller: SapConnectionController;
    canEdit: boolean;
}

export function ClientSapTab({ clientId, controller, canEdit }: Props) {
    return (
        <Box>
            <SapConnectionSection clientId={clientId} controller={controller} canEdit={canEdit} />
        </Box>
    );
}
